import { RequestOptions } from "./types/Request";
import { useState } from "react";
import { BASE_URL } from "../utils/http";
import { INews } from "../types/News";

export const useEditNews = (requestOptions: RequestOptions) => {
  const [loading, setLoading] = useState(false);
  const editNews = async (news: INews) => {
    const {
      id,
      title,
      body,
      sectionId,
      description,
      featureImageUrl,
      newsStatus,
    } = news;
    setLoading(true);
    BASE_URL.put(`/news/${id}`, {
      title,
      body,
      sectionId,
      description,
      featureImageUrl,
      newsStatus,
    })
      .then((res) => {
        requestOptions.onSuccess && requestOptions.onSuccess(res.data);
        setLoading(false);
      })
      .catch((e: any) => {
        requestOptions.onError && requestOptions.onError(e.response.data);
        setLoading(false);
      });
  };
  return { editNews, loading };
};
